import React, { Component } from "react";
import { Spinner } from "@blueprintjs/core"
import { DropTarget } from 'react-dnd';
import { TASK_STATUS, TASK_STATUS_COLOR, PMDNDTypes } from "../../constants";
import AssignedColumnCard from "./AssignedColumnCard";

class WorkloadColumn extends Component {

	loading = () => {
		return <div style={{ textAlign: 'center' }}>
			<Spinner />
		</div>;
	}

	render() {
		const p = this.props;
		return (
			p.connectDropTarget(
				<div className={"PMTaskGroup" + (p.hovered === true ? " PMHover" : "")}>
					<div className={"PMTaskGroupHeader"}>
						<div className={"PMTaskGroupHeaderLeft"}>
							<div>
								<h2 >
									{p.columnTitle === null ? "Unassigned" : p.columnTitle}
								</h2>
							</div>
						</div>
						<div className={"PMTaskGroupHeaderRight"}>
						</div>
					</div>
					<div className={"PMTaskGroupLine"}></div>
					{p.isLoading === true ? this.loading() : this.list()}
				</div >
			)
		);
	}

	isInPhase = (t) => {
		let result = false;
		if (this.props.phaseID === t.phaseID) {
			result = true;
		}
		return result;
	}

	list = () => {
		const p = this.props;
		let filteredTasks = p.tasks.filter(this.isInPhase);
		return filteredTasks.map((task, i) => {
			if (task.assigned[0] === p.uniqueID) { // PRIMARY
				return (
					<AssignedColumnCard
						task={task}
						key={p.columnTitle + "_assigned_card_" + i}
						color={TASK_STATUS_COLOR[task.status]}
						index={i}
					/>
				)
			} else if (task.assigned.includes(p.uniqueID)) { // ADDITIONAL
				return (
					<AssignedColumnCard
						also
						task={task}
						key={p.columnTitle + "_assigned_card_" + i}
						color={TASK_STATUS_COLOR[task.status]}
						index={i}
					/>
				)
			} else if (p.columnTitle === null && task.assigned.length === 0) {
				return (
					<AssignedColumnCard
						task={task}
						key={p.columnTitle + "_unassigned_card_" + i}
						color={TASK_STATUS_COLOR[task.status]}
						index={i}
					/>
				)
			}
		});

	};

}

const dropSource = {
	drop: function (props, monitor, component) {
		const item = monitor.getItem();
		if (item.colIndex !== component.props.colIndex) {
			component.props.moveTask(
				item.task,
				props.uniqueID
			);
		}
	},

}

function dropCollect(connect, monitor) {
	return {
		connectDropTarget: connect.dropTarget(),
		hovered: monitor.isOver({ shallow: true })
	}
}

export default DropTarget(PMDNDTypes.WINDOW, dropSource, dropCollect)(WorkloadColumn);



// WEBPACK FOOTER //
// ./src/components/projectmanager/new/Assigned/WorkloadColumn.js